Vue.filter('newLine', function (value) {
    value = value + '';
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
});
